import {throttled, fetch} from '~/lib/fetch';
import config from '~/configuration';

const retrieve = throttled(async () => {
  const response = await fetch(config.api, {
    method: 'POST',
    body: JSON.stringify({
      query: `
        query Query {
            overview: overview {
              status
              request_type
              count
            }
          }    
        `,
    }),
  });

  const {overview} = await response.json();

  return overview.reduce((acc, {status, request_type, count}) => {
    return {
      ...acc,
      [request_type]: {
        ...(acc[request_type] ?? {}),
        [status]: count,
      },
    };
  }, {});
});

export default {
  retrieve,
};
